import type * as Types from '../../types';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import document from './rootPlaceMenuItemQuery.gql';
import type * as ApolloReactCommon from '~/lazy_apollo/client';
import * as ApolloReactHooks from '~/lazy_apollo/client';
const defaultOptions = {} as const;
export type RootPlaceMenuItemQuery_rootPlace_RootPlace_menuItem_MenuItem_featuredPhoto_MenuItemPosPhoto = {
  __typename: 'MenuItemPosPhoto',
  id: number,
  photoUrl?: string | null,
  shareUrl?: string | null
};

export type RootPlaceMenuItemQuery_rootPlace_RootPlace_menuItem_MenuItem_featuredPhoto_Photo = {
  __typename: 'Photo',
  id: number,
  photoUrl?: string | null,
  shareUrl?: string | null
};

export type RootPlaceMenuItemQuery_rootPlace_RootPlace_menuItem_MenuItem_featuredPhoto =
  | RootPlaceMenuItemQuery_rootPlace_RootPlace_menuItem_MenuItem_featuredPhoto_MenuItemPosPhoto
  | RootPlaceMenuItemQuery_rootPlace_RootPlace_menuItem_MenuItem_featuredPhoto_Photo
;

export type RootPlaceMenuItemQuery_rootPlace_RootPlace_menuItem_MenuItem_location_RestaurantLocation = {
  __typename: 'RestaurantLocation',
  id: number,
  city: string,
  countryName: string,
  eatPopCtaLinkUrl: string,
  eatPopCtaText: string,
  state?: string | null
};

export type RootPlaceMenuItemQuery_rootPlace_RootPlace_menuItem_MenuItem_recentUserAvatars_UserAvatar = {
  __typename: 'UserAvatar',
  id: string,
  avatarUrl: string,
  displayName: string
};

export type RootPlaceMenuItemQuery_rootPlace_RootPlace_menuItem_MenuItem_restaurant_Restaurant = {
  __typename: 'Restaurant',
  id: number,
  name: string,
  popmenuUrl?: string | null
};

export type RootPlaceMenuItemQuery_rootPlace_RootPlace_menuItem_MenuItem = {
  __typename: 'MenuItem',
  id: number,
  description?: string | null,
  displayName: string,
  generatedCategoryName?: string | null,
  generatedDescription?: string | null,
  generatedReviewsSummary?: string | null,
  idAsSlug: string,
  popsCount: number,
  rootDishCategorySlug?: string | null,
  featuredPhoto?: RootPlaceMenuItemQuery_rootPlace_RootPlace_menuItem_MenuItem_featuredPhoto | null,
  location?: RootPlaceMenuItemQuery_rootPlace_RootPlace_menuItem_MenuItem_location_RestaurantLocation | null,
  recentUserAvatars: Array<RootPlaceMenuItemQuery_rootPlace_RootPlace_menuItem_MenuItem_recentUserAvatars_UserAvatar>,
  restaurant: RootPlaceMenuItemQuery_rootPlace_RootPlace_menuItem_MenuItem_restaurant_Restaurant
};

export type RootPlaceMenuItemQuery_rootPlace_RootPlace = {
  __typename: 'RootPlace',
  id: number,
  menuItem?: RootPlaceMenuItemQuery_rootPlace_RootPlace_menuItem_MenuItem | null
};

export type RootPlaceMenuItemQuery_Query = {
  __typename?: 'Query',
  rootPlace: RootPlaceMenuItemQuery_rootPlace_RootPlace
};


export type RootPlaceMenuItemQueryVariables = Types.Exact<{
  rootPlaceSlug: Types.Scalars['String']['input'];
  menuItemId: Types.Scalars['Int']['input'];
}>;


export type RootPlaceMenuItemQuery = RootPlaceMenuItemQuery_Query;


export const RootPlaceMenuItemDocument = /*#__PURE__*/ document as unknown as DocumentNode<RootPlaceMenuItemQuery, RootPlaceMenuItemQueryVariables>;


/**
 * __useRootPlaceMenuItemQuery__
 *
 * To run a query within a React component, call `useRootPlaceMenuItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useRootPlaceMenuItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRootPlaceMenuItemQuery({
 *   variables: {
 *      rootPlaceSlug: // value for 'rootPlaceSlug'
 *      menuItemId: // value for 'menuItemId'
 *   },
 * });
 */
export function useRootPlaceMenuItemQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RootPlaceMenuItemQuery, RootPlaceMenuItemQueryVariables> & ({ variables: RootPlaceMenuItemQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RootPlaceMenuItemQuery, RootPlaceMenuItemQueryVariables>(RootPlaceMenuItemDocument, options);
      }
export function useRootPlaceMenuItemLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RootPlaceMenuItemQuery, RootPlaceMenuItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RootPlaceMenuItemQuery, RootPlaceMenuItemQueryVariables>(RootPlaceMenuItemDocument, options);
        }
export function useRootPlaceMenuItemSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RootPlaceMenuItemQuery, RootPlaceMenuItemQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RootPlaceMenuItemQuery, RootPlaceMenuItemQueryVariables>(RootPlaceMenuItemDocument, options);
        }
export type RootPlaceMenuItemQueryHookResult = ReturnType<typeof useRootPlaceMenuItemQuery>;
export type RootPlaceMenuItemLazyQueryHookResult = ReturnType<typeof useRootPlaceMenuItemLazyQuery>;
export type RootPlaceMenuItemSuspenseQueryHookResult = ReturnType<typeof useRootPlaceMenuItemSuspenseQuery>;
export type RootPlaceMenuItemQueryResult = ApolloReactCommon.QueryResult<RootPlaceMenuItemQuery, RootPlaceMenuItemQueryVariables>;